export class ErrorResultModel {
    public title?: Record<string, string>;
    public erros?: string;
    public status?: string;
    public type?: string;
    public traceId?: string;
}
